(function () {
  angular
    .module("akitabox.ui.dialogs.asset.delete")
    .factory("DeleteAssetDialog", DeleteAssetDialog);

  /* @ngInject */
  function DeleteAssetDialog($log, $q, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl: "app/core/ui/dialogs/asset/delete/delete-asset.dialog.html",
      controller: "DeleteAssetDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.assetIDs` and `options.locals.building` are required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error>}              Promise that resolves with the deleted assets
     */
    function show(options) {
      // Verify we have assetIDs and building locals
      if (
        !options ||
        !options.locals ||
        !options.locals.assetIDs ||
        !(options.locals.building || options.locals.buildingId)
      ) {
        $log.error(
          "DeleteAssetDialog: you must pass in assetIDs and building via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
